import React, { useState } from "react";
import classes from "./TagInputSignUp.module.scss";
import { faEye, faEyeSlash, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getKeyGen } from "../../../../helpers";
import { useTranslation } from "react-i18next";
// import InputMask from "react-input-mask";
import { IMaskInput as InputMask } from 'react-imask';
import { Box } from "@mui/material";

const TagInputSignUp = ({
  autoComplete = "off",
  centerText = false,
  className = "",
  errors = null,
  forward_ref = null,
  label = null,
  maxLength = "",
  required = true,
  msgInfo = false,
  name = "",
  onChange = "",
  onBlur = null,
  parentClass = null,
  placeholder = "",
  type = "text",
  value = "",
  typeError = "",
  suggestedText = "",
  mask = "",
  inputmode = "",
  errorButton = "",
  showTextError = "",
  textError = "",
  max = "",
  sx={}
}) => {
  const { t } = useTranslation();
  const [isPasswodShow, setIsPasswodShow] = useState(false);
  let errorClass = classes.Error;
  const inputeCenterClass = centerText ? " " + classes.CenterText : "";
  const isPasswod = type === "password";
  let tempType = type;

  const keyPresed = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setIsPasswodShow(!isPasswodShow);
    }
  };

  if (isPasswodShow) tempType = "text";
  if (msgInfo) errorClass = classes.Error + " " + classes.MsgInfo;
  if (className) className = " " + className;
  let finalInput = (
    <Box className={className} sx={sx}>
      {label && (
        <label className={classes.Label} htmlFor={"id_" + [name]}>
          {label} {required && <b>*</b>}
        </label>
      )}
      <div className={classes.InputEyeArea}>
        <input
          className={
            showTextError && errorButton
              ? { "error": classes.TagInputError, "warn": classes.TagInputWarning, "": classes.TagInputError }[typeError] + inputeCenterClass
              : classes.TagInput + inputeCenterClass
          }
          value={value}
          mask={mask}
          inputMode={inputmode}
          id={getKeyGen("id_" + name)}
          maxLength={parseInt(maxLength)}
          max={(Date.parse(max)) ? max : (max) ? parseInt(max) : null}
          name={name}
          type={tempType}
          required={required}
          autoComplete={autoComplete}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          ref={forward_ref}
        />
        {showTextError && errorButton && (
          {
            "": (<div className={classes.errorDiv}>{textError}</div>),
            "error": (
              <div className={classes.errorDiv}>
                <FontAwesomeIcon className={classes.ButtonErrorSVG} icon={faExclamationTriangle} />
                {textError}
                {suggestedText ?
                  (<><button onClick={() => { value = suggestedText; onChange({ target: { name, value } }); }} className={classes.ButtonError} type="button">{suggestedText}</button> ?</>)
                  :
                  null
                }
              </div>
            ),
            "warn": (
              <div className={classes.warningDiv}>
                <FontAwesomeIcon className={classes.ButtonErrorSVG} icon={faExclamationTriangle} />
                {textError}
                <button onClick={() => { value = suggestedText; onChange({ target: { name, value } }); }} className={classes.ButtonError} type="button">{suggestedText}</button> ?
              </div>
            )
          }[typeError]
        )}
        {isPasswod && (
          <FontAwesomeIcon
            onKeyDown={(e) => keyPresed(e)}
            tabIndex="0"
            title={
              isPasswodShow
                ? t("global.show_password")
                : t("global.hide_password")
            }
            onClick={() => setIsPasswodShow(!isPasswodShow)}
            icon={isPasswodShow ? faEye : faEyeSlash}
          />
        )}
      </div>
      {errors && errors[[name]] && errors[[name]].message !== "" && (
        <p className={errorClass}>{errors[[name]].message}</p>
      )}
    </Box>
  );
  if (parentClass) {
    finalInput = <div className={parentClass}> {finalInput}</div>;
  }
  return finalInput;
};

export default TagInputSignUp;
